import React from "react";

function AutoResizeTextarea({ value, onChange, className }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (ref.current) {
      ref.current.style.height = "auto";
      ref.current.style.height = ref.current.scrollHeight + "px";
    }
  }, [value]);

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={onChange}
      rows={3}
      className={`w-full resize-none bg-transparent outline-none text-sm leading-relaxed ${className}`}
    />
  );
}

export default AutoResizeTextarea;
